<template>
  <SecondaryModal name="delete-chat-matrix" :title="$t('leaveChatTitle')" @before-open="reset">
    <div v-html="$t('leaveChatConfirmation', { name: currentRoom && currentRoom.name })"></div>
    <template v-slot:footer>
      <BaseButton oval secondary @click="$modal.hide('delete-chat-matrix')">{{ $t('buttonCancel') }}</BaseButton>
      <BaseButton oval :loading="loading" @click="deleteRequest">{{ $t('buttonDelete') }}</BaseButton>
    </template>
  </SecondaryModal>
</template>

<script>
import SecondaryModal from './SecondaryModal'
import { mapGetters, mapMutations } from 'vuex'
import { parseRouterQueryParam } from '@/helpers/index'

export default {
  name: 'delete-chat-popup-matrix',
  components: {
    SecondaryModal
  },
  data () {
    return {
      loading: false
    }
  },
  computed: {
    ...mapGetters({
      currentRoom: 'matrix/currentRoom'
    }),
    chatId () {
      return parseRouterQueryParam(this.$route.query.id, true)
    }
  },
  methods: {
    ...mapMutations({
      deleteChatMessages: 'matrix/DELETE_MESSAGES_FROM_CURRENT_ROOM',
      removeRoomFromList: 'matrix/REMOVE_ROOM_FROM_LIST',
      setCurrentRoom: 'matrix/SET_CURRENT_ROOM'
    }),
    reset () {
      this.loading = false
    },
    async deleteRequest () {
      const chatId = this.chatId
      this.loading = true
      await this.$router.replace({ name: 'app-chat' })
      setTimeout(() => {
        this.deleteChatMessages()
        this.setCurrentRoom(null)
        this.removeRoomFromList({ id: chatId })
        window.matrixSDK
          .leave(chatId)
          // eslint-disable-next-line no-console
          .catch(error => console.error(error))
          .finally(() => {
            window.matrixSDK
              .forget(chatId)
              // eslint-disable-next-line no-console
              .catch(error => console.error(error))
          })
      }, 0)
      this.loading = false
      this.$modal.hide('delete-chat-matrix')
    }
  }
}
</script>

<style module lang="scss">
.switchContainer {
  margin-top: 8px;
  display: inline-block;
}
</style>
